import { CRS, Renderer } from "leaflet";
import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Popup } from "react-leaflet";
import PolygonWithText from "./PolygonWithText";
import poly_processed_file from "./poly_processed.json";
const poly_processed: any = poly_processed_file;
const COLOR: any = {
  district_1: "#FFFFFF",
  district_2: "#FFFFFF",
  district_3: "#FFFFFF",
  district_4: "#FFFFFF",
  district_5: "#FFFFFF",
  district_6: "#FFFFFF",
  district_7: "#FFFFFF",
  district_8: "#FFFFFF",
  district_9: "#FFFFFF",
};
const NAME: any = {
  district_1: "Greenfield",
  district_2: "Vienna",
  district_3: "Oyster Bay",
  district_4: "Riverside",
  district_5: "South port",
  district_6: "Manhattan",
  district_7: "Newshire",
  district_8: "Kingston",
  district_9: "Ibiza",
};
function EmeraldCityMap() {
  const [isInteractable, setIsInteractable] = useState(false);
  const interactable = () => {
    setIsInteractable(!isInteractable);
  };
  return (
    <div
      style={{
        width: "100%",
        height: "500px",
        position: "relative",
        zIndex: "1",
        margin: "4rem 0px",
      }}
    >
      {isInteractable ? null : (
        <div
          className="emerald_city_map_overlay"
          style={{
            width: "100%",
            height: "500px",
            cursor: "pointer",
            position: "absolute",
            background: "rgba(0,0,0,0.2)",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            top: "0",
            bottom: "0",
            zIndex: "2",
            justifyContent: "space-around",
          }}
          onClick={interactable}
        >
          Click and zoom on the map to interact
        </div>
      )}
      <div
        onMouseLeave={interactable}
        className="emerald_city_map_container"
        style={{
          width: "100%",
          height: "500px",
          position: "relative",
          overflow: "hidden",
          zIndex: "1",
          margin: "15px 0px",
        }}
      >
        <MapContainer
          center={[-130, 123]}
          zoom={3}
          maxZoom={6}
          crs={CRS.Simple}
          zoomAnimation={true}
          fadeAnimation={true}
          preferCanvas={true}
          style={{
            width: "100%",
            height: "500px",
            background: "#163340",
          }}
          minZoom={3}
          scrollWheelZoom={true}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://d1d1929yj98sm3.cloudfront.net/tile_maps/{z}/{x}/{y}.png"
          />
          {Object.keys(poly_processed).map((key, index) => {
            return (
              <PolygonWithText
                key={index}
                text={NAME[key]}
                pathOptions={{
                  color: COLOR[key],
                  weight: 0.1,
                  fill: true,
                  fillColor: COLOR[key],
                  fillOpacity: 0.01,
                }}
                eventHandlers={{
                  mouseover: (e: any) => {
                    console.log(e.target);
                    e.target.setStyle({
                      fillOpacity: 0.07,
                    });
                  },
                  mouseout: (e: any) => {
                    console.log(e.target.options.fillOpacity);
                    e.target.setStyle({
                      fillOpacity: 0.01,
                    });
                  },
                }}
                positions={poly_processed[key]}
              />
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
}

export default EmeraldCityMap;
